import {
  DOWNLOADSAMPLEFILEOFCURRENCYRATE_SUCCESS,
  DOWNLOADSAMPLEFILEOFCURRENCYRATE_FAILED,
  RESET_DOWNLOADSAMPLEFILEOFCURRENCYRATE,
  LOADING_DOWNLOADSAMPLEFILEOFCURRENCYRATE,
  NETWORK_ERROR_DOWNLOADSAMPLEFILEOFCURRENCYRATE,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetDownloadSampleFileOfCurrencyRate = () => {
  return { type: RESET_DOWNLOADSAMPLEFILEOFCURRENCYRATE };
};

const downloadSampleFileOfCurrencyRateApi =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DOWNLOADSAMPLEFILEOFCURRENCYRATE });
    await partnerServices
      .post(
        "downloadSampleFileOfCurrencyRate", userData, { headers: { AuthToken: authTokenIs } }
      )
      .then((res) => {
        switch (res.data.status) {
          case "success":
            dispatch(downloadSampleFileOfCurrencyRateSuccess(res.data));
            break;
          default:
            dispatch(downloadSampleFileOfCurrencyRateFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_DOWNLOADSAMPLEFILEOFCURRENCYRATE,
          payload: err,
        });
      });
  };
function downloadSampleFileOfCurrencyRateSuccess(data) {
  return {
    type: DOWNLOADSAMPLEFILEOFCURRENCYRATE_SUCCESS,
    payload: data,
  };
}
function downloadSampleFileOfCurrencyRateFailed(data) {
  return {
    type: DOWNLOADSAMPLEFILEOFCURRENCYRATE_FAILED,
    payload: data,
  };
}

export {
  resetDownloadSampleFileOfCurrencyRate,
  downloadSampleFileOfCurrencyRateApi,
};
